import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-cy": "profileData",
  class: "rounded-md bg-greyLight p-5 text-sm leading-7 text-grey"
}
const _hoisted_2 = { class: "text-gray-500" }
const _hoisted_3 = { class: "text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfilePageSkeleton = _resolveComponent("ProfilePageSkeleton")!
  const _component_StandartTemplate = _resolveComponent("StandartTemplate")!

  return (_openBlock(), _createBlock(_component_StandartTemplate, null, {
    default: _withCtx(() => [
      (_ctx.userData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _cache[0] || (_cache[0] = _createTextVNode(" ФИО: ", -1)),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.userData.full_name), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[1] || (_cache[1] = _createTextVNode(" Номер телефона: ", -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userData.phone_number), 1)
            ])
          ]))
        : (_openBlock(), _createBlock(_component_ProfilePageSkeleton, { key: 1 }))
    ]),
    _: 1
  }))
}